module.exports = __webpack_public_path__ + "img/7.92c0a3b.webp";